import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ConfirmationDialogComponent } from './confirmation-dialog/confirmation-dialog.component';

@Injectable({ providedIn: 'root' })
export class DialogManagerService {
    constructor(private matDialog: MatDialog) { }

    /** Close only the most recently opened dialog, if any exist. */
    closeTopDialog(): void {
        const { openDialogs } = this.matDialog;
        if (openDialogs.length === 0) {
            return;
        }
        openDialogs[openDialogs.length - 1].close();
    }

    /** Prompt the user before closing the top-most dialog via global controls. */
    confirmCloseTopDialog(): void {
        const { openDialogs } = this.matDialog;
        if (!openDialogs.length) {
            return;
        }
        openDialogs[openDialogs.length - 1].close();

        // const targetDialog: MatDialogRef<unknown> = openDialogs[openDialogs.length - 1];

        // const confirmationRef = this.matDialog.open(ConfirmationDialogComponent, {
        //     maxWidth: '420px',
        //     data: {
        //         title: 'Close dialog?',
        //         messagesArray: ['Are you sure you want to close the current dialog? Unsaved changes might be lost.'],
        //         confirmText: 'Close dialog',
        //         cancelText: 'Keep Open',
        //         icon: 'highlight_off',
        //         iconColor: 'var(--mat-sys-primary)'
        //     }
        // });

        // confirmationRef.afterClosed().subscribe((confirmed: boolean) => {
        //     if (!confirmed) {
        //         return;
        //     }

        //     if (!this.matDialog.openDialogs.includes(targetDialog)) {
        //         return;
        //     }

        //     targetDialog.close();
        // });
    }

    /** Close all dialogs across the application. */
    closeAllDialogs(): void {
        this.matDialog.closeAll();
    }

    /** Whether there are any dialogs currently open. */
    hasOpenDialogs(): boolean {
        return this.matDialog.openDialogs.length > 0;
    }
}
